import React from "react";
import "./styles.css";

const PAGE_SIZE_OPTIONS = [5, 10, 20, 50, 100];

class Pagination extends React.Component {
  getPageNumbers() {
    const { page, totalPageCount } = this.props;
    const total = totalPageCount || 1;

    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    const pages = [1];

    if (page > 3) pages.push("...");

    const start = Math.max(2, page - 1);
    const end = Math.min(total - 1, page + 1);
    for (let i = start; i <= end; i++) pages.push(i);

    if (page < total - 2) pages.push("...");
    pages.push(total);

    return pages;
  }

  render() {
    const {
      firstPage,
      nextPage,
      prevPage,
      totalPageCount,
      totalRecords,
      page,
      length,
      limit,
      onLimitChange,
    } = this.props;

    const safeLimit = Number(limit) || length || 0;
    const clampedLength = safeLimit > 0 ? Math.min(length, safeLimit) : length;
    const startCount = length === 0 ? 0 : (page - 1) * safeLimit + 1;
    const endCount = (page - 1) * safeLimit + clampedLength;
    const total = totalRecords || null;

    const isFirstPage = page === firstPage;
    const isLastPage = length === 0 || page === totalPageCount;

    return (
      <div className="pagination-container">
        <div className="pagination-info">
          <span className="pagination-showing">
            Showing <strong>{startCount}</strong>–<strong>{endCount}</strong>
            {total > 0 && (
              <> of <strong>{total}</strong> results</>
            )}
          </span>
          {safeLimit > 0 && (
            <>
              <span className="pagination-sep">|</span>
              <span className="pagination-per-page-label">Show</span>
              <select
                className="pagination-limit-select"
                value={safeLimit}
                onChange={(e) => onLimitChange && onLimitChange(Number(e.target.value))}
              >
                {PAGE_SIZE_OPTIONS.map((opt) => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
              </select>
              <span className="pagination-per-page-label">per page</span>
            </>
          )}
        </div>

        <div className="pagination-controls">
          <button
            className={`pagination-nav-btn${isFirstPage ? " disabled" : ""}`}
            onClick={!isFirstPage ? prevPage : undefined}
            disabled={isFirstPage}
          >
            <span className={process.env.REACT_APP_ICONS_TYPE}>chevron_left</span>
            Prev
          </button>

          {this.getPageNumbers().map((p, i) =>
            p === "..." ? (
              <span key={`e-${i}`} className="pagination-ellipsis">…</span>
            ) : (
              <button
                key={p}
                className={`pagination-page-btn${page === p ? " active" : ""}`}
                onClick={() => page !== p && this.props.paginate(p)}
              >
                {p}
              </button>
            )
          )}

          <button
            className={`pagination-nav-btn${isLastPage ? " disabled" : ""}`}
            onClick={!isLastPage ? nextPage : undefined}
            disabled={isLastPage}
          >
            Next
            <span className={process.env.REACT_APP_ICONS_TYPE}>chevron_right</span>
          </button>
        </div>
      </div>
    );
  }
}

export default Pagination;
